export default __webpack_public_path__ + "static/media/CSS3_white.028d45d6.webp";